export default function AboutSection() {
  return (
    <section className="w-full bg-white py-20 md:py-28">
      <div className="w-full px-6 md:px-16">
        <div className="flex flex-col lg:flex-row gap-12 items-stretch">
          {/* Left image */}
          <div className="w-full lg:w-1/2">
            <div className="w-full h-[380px] md:h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20Japanese%20business%20team%20meeting%20modern%20bright%20office%20minimalist%20interior%20consulting%20firm%20warm%20natural%20light%20contemporary%20workspace%202019%20style%20corporate%20strategy%20discussion&width=700&height=500&seq=about-1&orientation=landscape"
                alt="株式会社ＡＬＡ チーム"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right content */}
          <div className="w-full lg:w-1/2 flex flex-col justify-between gap-8">
            {/* Text */}
            <div>
              <p className="text-xs tracking-[0.3em] text-[#C8501A] uppercase mb-3">About ALA</p>
              <h2 className="text-3xl md:text-4xl font-black text-[#0A0E1A] leading-tight mb-6">
                私たちについて
              </h2>
              <p className="text-sm text-[#6B6560] leading-relaxed mb-4">
                株式会社ＡＬＡは、2019年6月に東京都豊島区にて設立されました。
                「戦略で未来を動かす」という理念のもと、各種コンサルティングと広告業を軸に、
                店舗・空間デザイン、人材育成まで幅広いソリューションを提供しています。
              </p>
              <p className="text-sm text-[#6B6560] leading-relaxed">
                地方から全国へ。東京を拠点に培った知見とネットワークを活かし、
                クライアントのビジネス成長に真摯に向き合い続けています。
              </p>
            </div>

            {/* CEO card */}
            <div className="bg-[#0A0E1A] rounded-2xl p-6 md:p-8 flex items-center gap-6">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-[#C8501A]/20 border border-[#C8501A]/40 flex items-center justify-center flex-shrink-0">
                <i className="ri-user-line text-2xl text-[#C8501A]" />
              </div>
              <div>
                <p className="text-xs tracking-widest text-[#C8501A] uppercase mb-1">代表取締役</p>
                <p className="text-xl font-black text-white mb-1">山崎翔太郎</p>
                <p className="text-xs text-white/40">2019年設立 / 東京都豊島区</p>
              </div>
            </div>

            {/* Company info */}
            <div className="grid grid-cols-2 gap-4">
              {[
                { label: '会社名', value: '株式会社ＡＬＡ' },
                { label: '設立', value: '2019年6月5日' },
                { label: '所在地', value: '東京都豊島区南長崎２丁目１２番１０号レーベンシュロス２０２号' },
                { label: '代表', value: '山崎翔太郎' },
              ].map(({ label, value }) => (
                <div key={label} className="border-l-2 border-[#C8501A] pl-3">
                  <p className="text-xs text-[#9C9490] mb-0.5">{label}</p>
                  <p className="text-sm font-medium text-[#0A0E1A]">{value}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
